var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 4v1.5h3.75V4a1.874 1.874 0 1 0-3.75 0M4 5.5V4a3 3 0 1 1 6 0v1.5h.75c.827 0 1.5.673 1.5 1.5v4.5c0 .828-.673 1.5-1.5 1.5h-7.5c-.827 0-1.5-.672-1.5-1.5V7c0-.827.673-1.5 1.5-1.5zM2.875 7v4.5c0 .207.169.375.375.375h7.5a.376.376 0 0 0 .375-.375V7a.376.376 0 0 0-.375-.375h-7.5A.376.376 0 0 0 2.875 7"
  })));
};
export default SvgLock;